import React from 'react'
import _ from 'lodash'

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion';

const LinkListWrapper = ({ entity: { fieldTitle, fieldRijksvideo } }) => {
  const title = fieldTitle;
  const audio = _.get(fieldRijksvideo, 'entity.fieldRijksvideoAudio');
  const sources = JSON.parse(_.get(fieldRijksvideo, 'entity.fieldRijksvideoBronnen', '{}'));
  const duration =  _.get(fieldRijksvideo, 'entity.fieldRijksvideoDuratie');
  const thumbnail = _.get(fieldRijksvideo, 'entity.fieldRijksvideoThumbnail.entity.uri.url');
  const transcription = _.get(fieldRijksvideo, 'entity.fieldRijksvideoTranscriptie');
  const caption =  _.get(fieldRijksvideo, 'entity.fieldRijksvideoOndertiteling.entity.uri.url');;

  let videoSource;
  if (!_.isEmpty(sources['web_hd']['url'])) {
    videoSource = sources['web_hd']['url'];
  }
  else if (!_.isEmpty(sources['web_mp4']['url'])) {
    videoSource = sources['web_mp4']['url'];
  }

  return (
    <div className="rijksvideo">
      <video
        className="rijksvideo-element"
        width="100%"
        height="auto"
        controls="controls"
        preload="none"
        poster={thumbnail}
      >
        <source src={videoSource}/>
        {caption && <track label="Nederlands" kind="subtitles" srcLang="nl" src={caption}/>}
      </video>
      <Accordion allowZeroExpanded={true} className={'accordion'}>
          {audio &&
            <AccordionItem>
              <AccordionItemHeading aria-level={4}>
                <AccordionItemButton>
                  <div className="title">Download audio <span className="accordion__arrow" /></div>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className="audio-downloads ">
                    <li><a href={audio}>Download in MP3 formaat</a></li>
                </ul>
              </AccordionItemPanel>
            </AccordionItem>
          }
          <AccordionItem>
            <AccordionItemHeading aria-level={4}>
              <AccordionItemButton>
                <div className="title">Download video <span className="accordion__arrow" /></div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="video-downloads ">
                {_.map(sources, (source, i) => (
                  <li key={i}>
                    <a href={source.url}>Download in {source.type} formaat</a> ({source.type} | {source.size})
                  </li>
                ))}
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
          {transcription && (
            <AccordionItem>
              <AccordionItemHeading aria-level={4}>
                <AccordionItemButton>
                  <div className="title">Uitgeschreven tekst <span className="accordion__arrow" /></div>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <div>{transcription}</div>
              </AccordionItemPanel>
            </AccordionItem>
          )}
      </Accordion>
    </div>
  )

}

export default LinkListWrapper
